<template>
  <v-dialog
    width="600px"
    title="View Meeting Content"
    :visible.sync="dialogMeetingVisible"
    @close="onClose"
    @closed="onClosed"
    split-line
  >
    <el-form label-width="190px" class="padding-lr">
      <template v-if="data">
        <el-form-item label="Meeting Title">
          <span>{{ data.CategoryName }}</span>
        </el-form-item>
        <el-form-item label="PDF Attached">
          <a :href="data.AttachmentPath" target="blank">{{ data.FileName }}</a>
        </el-form-item>
        <el-form-item class="content-container" label="Content">
          <div
            ref="contentWrapper"
            class="content-wrapper"
            v-html="data.PaperContent"
          ></div>
        </el-form-item>
      </template>
    </el-form>
  </v-dialog>
</template>
<script>
export default {
  name: "view-team-content-dialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true,
    },
    data: Object,
  },
  data() {
    return {
      dialogMeetingVisible: this.visible,
    };
  },
  computed: {
    url() {
      return this.data
        ? `${process.env.VUE_APP_SERVER}/upload/paper/${this.data.Attachment}`
        : "/";
    },
  },
  watch: {
    visible(value) {
      this.dialogMeetingVisible = value;
    },
  },
  methods: {
    onClose() {
      const contentWrapper = this.$refs.contentWrapper;
      if (contentWrapper) {
        contentWrapper.scrollTop = 0;
      }
    },
    onClosed() {
      this.$emit("update:data", null);
      this.$emit("update:visible", false);
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .el-scrollbar.dialog {
    max-height: 100%;
    width: 600px;
    min-width: 600px;
    min-height: 10vw;
    .el-scrollbar__wrap {
      margin-bottom: 0 !important;
    }
  }
  .el-dialog__header {
    padding: 20px;
  }
  .el-form-item__label {
    color: #555;
    font-weight: bold;
  }
  .el-dialog__footer {
    padding: 0;
  }
  .el-dialog__body {
    padding: 0px;
    display: flex;
    max-height: 70vh;
  }
}
.el-form {
  position: relative;
  padding: 30px 40px 0 15px;
  .el-form-item.content-container {
    margin-bottom: 0px;
  }
}
.link-wrap {
  max-width: 95%;
}
.content-wrapper {
  font-size: 14px;
  display: inline-block;
  min-height: 50px;
  max-height: 180px;
  overflow: scroll;
  width: 100%;
  padding-right: 10px;
  ::v-deep {
    figure {
      display: inherit;
    }
    img {
      max-width: 250px;
      height: auto;
    }
  }
}
</style>
